import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'closedPackageReceivedDate',
    label: 'Closed Package Received Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'postClosingReviewCompleted',
    label: 'Post-Closing Review Completed',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'investorLockDate',
    label: 'Investor Lock Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'investorLockExpiration',
    label: 'Investor Lock Expiration',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'transmissionConfirmationDate',
    label: 'Transmission Confirmation Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'correctionInProcessDate',
    label: 'Correction In Process Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'unrecordedMortgageReceivedDate',
    label: 'Unrecorded Mortgage Received Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'copyOfRecordedMortgageReceivedDate',
    label: 'Copy of Recorded Mortgage Received Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'recordedMortgageUploadedDate',
    label: 'Recorded Mortgage Uploaded Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'titlePolicyUploadedDate',
    label: 'Title Policy Uploaded Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'tpMtgInFileCabinetDate',
    label: 'TP Mtg In File Cabinet Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'noteReturnedDate',
    label: 'Note Returned Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'noteReturnedReason',
    label: 'Note Returned Reason',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'finalDocumentsComments',
    label: 'Final Documents Comments',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'noteMissingFromClosedPackage',
    label: 'Note Missing from Closed Package',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'postClosingReviewDefects',
    label: 'Post-Closing Review Defects',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'preppedForTransmissionDate',
    label: 'Prepped for Transmission Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'loanTransmittedDate',
    label: 'Loan Transmitted Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'transmissionComments',
    label: 'Transmission Comments',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'mortgagePaidOffTitlePolicyNotRequired',
    label: 'Mortgage Paid Off - Title Policy Not Required',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'titlePolicyRequestedDate',
    label: 'Title Policy Requested Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'titlePolicyReceivedDate',
    label: 'Title Policy Received Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'titlePolicyCorrectionInProcessDate',
    label: 'Title Policy Correction In Process Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'titlePolicyDeliveredToInvestorDate',
    label: 'Title Policy Delivered to Investor Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'titlePolicyNotes',
    label: 'Title Policy Notes',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'recordedMortgageRequestedDate',
    label: 'Recorded Mortgage Requested Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'originalMortgageDeliveredDate',
    label: 'Original Mortgage Delivered Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'recordedMortgageDeliveredToInvestorDate',
    label: 'Recorded Mortgage Delivered to Investor Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'recordedMortgageNotes',
    label: 'Recorded Mortgage Notes',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const finalDocumentsForm = {
  name: FormNames.POST_CLOSING,
  label: 'Final Documents',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
